export default "__VITE_ASSET__Odb7Di$9__"